const isDefined = (value) => value !== null && value !== undefined && value !== '';

export default {
  toUpperCase: (value) => (isDefined(value) ? value.toUpperCase() : ''),
  toInteger: (value) => parseInt(value),
};
